module.exports = __webpack_public_path__ + "static/media/no-property.8d7a593b.jpg";